import { memo, useCallback, useMemo } from 'react';
import { ASPECT_RATIO_OPTIONS } from '../../ClipCustomizer/Layout/constants';
import ClipCustomizerLayoutIconButton from './ClipCustomizerLayoutIconButton';
import { changeSize } from '@/stores/clip';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { SizeType } from '@/domains/asset';

function ClipCustomizerAspectRatioOption({
  sizeOption,
  isDisabled = false,
  disabledReason = '',
  onHover = () => {}
}: {
  sizeOption: SizeType;
  isDisabled?: boolean;
  disabledReason?: string;
  onHover?: (aspectRatio: SizeType | null) => void;
}) {
  const { clipId, clipData } = useClipsContext();

  const clipSize = useMemo(() => {
    return clipData.asset_metadata.size;
  }, [clipData.asset_metadata.size]);

  const changeClipSize = useCallback(() => {
    changeSize(clipId, sizeOption);
  }, [clipId, sizeOption]);

  const onMouseEnter = useCallback(() => {
    onHover(sizeOption);
  }, [onHover, sizeOption]);

  const onMouseLeave = useCallback(() => {
    onHover(null);
  }, [onHover]);

  return (
    <ClipCustomizerLayoutIconButton
      optionDetails={ASPECT_RATIO_OPTIONS[sizeOption]}
      trackingId={`customizer-aspect-ratio-${sizeOption}`}
      onClick={changeClipSize}
      isActive={clipSize === sizeOption}
      isDisabled={isDisabled}
      disabledReason={disabledReason}
      tooltipPosition="left"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
}

export default memo(ClipCustomizerAspectRatioOption);
